import { getIBBroadcasts, getIBMessageGroups } from '@/api/ibModule';

export default {
  namespaced: true,

  state: () => ({
    sent: [],
    loaded: false,
    groups: [],
    groupedConversationIds: [],
  }),

  getters: {
    sentBroadcasts: (state) => state.sent,
    messageGroups: (state) => state.groups,
    groupedConversationIds: (state) => state.groupedConversationIds,
  },

  mutations: {
    setBroadcasts(state, broadcasts) {
      state.sent = broadcasts;
      state.loaded = true;
    },

    prependBroadcast(state, broadcast) {
      state.sent = [broadcast, ...state.sent];
    },

    setMessageGroups(state, { groups, grouped_conversation_ids: conversationIds }) {
      state.groups = groups || [];
      state.groupedConversationIds = conversationIds || [];
    },
  },

  actions: {
    async fetchBroadcasts({ commit }) {
      const { broadcasts } = await getIBBroadcasts();
      commit('setBroadcasts', broadcasts || []);
    },

    async fetchMessageGroups({ commit }) {
      commit('setMessageGroups', await getIBMessageGroups());
    },
  },
};
